module.exports = __webpack_public_path__ + "assets/img/home_solution_left.4678cfc2.png";